import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import type { BlockExport } from "../BuilderUI.types";
import { BlockPreview } from "./BlockPreview";

export interface BlockPreviewListProps {
  blocks: Array<[string, BlockExport]>;
  isElementType?: boolean;
}

export const BlockPreviewList = ({
  blocks,
  isElementType = false,
}: BlockPreviewListProps) => {
  if (isElementType) {
    return (
      <div className="grid grid-cols-2 gap-4">
        {blocks.map(([type, block]) => (
          <BlockPreview key={type} isElementType block={block} />
        ))}
      </div>
    );
  }

  return (
    <OverlayScrollbarsComponent className="w-2/3">
      <div className="flex w-full flex-col gap-6 px-6 py-5">
        {blocks.map(([type, block]) => (
          <BlockPreview key={type} block={block} />
        ))}
      </div>
    </OverlayScrollbarsComponent>
  );
};
